import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import update from "immutability-helper";
import _ from "lodash";

import { connect } from "react-redux";
import PActions from "../../Stores/redux/Persisted/Actions";
import UnpActions from "../../Stores/redux/Unpersisted/Actions";

import { isLoggedIn } from "../../Stores/redux/Persisted/Selectors";
import modules from "../../Modules";
import api from "../../Services/Api/api";
import withRouter from "../../Components/Wrapper/with-router";

const LoginScreenInner = (props) => {
  const { isLoggedIn, defaultScreen = "login" } = props;
  const [form, setForm] = useState({});
  const [formError, setFormError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loginRes, setLoginRes] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      const gotohome = () => {
        let defaultNextScreen = "/dashboard";
        let nextScreen =
          modules.navigation.getQuery("nextScreen") || defaultNextScreen;
        nextScreen = modules.navigation.matchCurrentPath(nextScreen)
          ? defaultNextScreen
          : nextScreen;

        navigate(nextScreen);
      };

      gotohome();
    }
  }, [isLoggedIn, navigate]);

  if (isLoggedIn) return null;

  const updateForm = (obj) => {
    setForm(update(form, { $merge: obj }));
  };
  const handleLogin = async (e) => {
    try {
      e.preventDefault();

      if (loading) return;
      setLoading(true);
      setFormError(null);

      const loginRes = await api.post("v1/user/login", {
        phone: form?.phone,
        password: form?.password,
        clientType: "web",
        deviceId: await modules.etc.getDeviceToken(),
        anyPermissions: ["districtAdmin"],
      });

      setLoading(false);

      modules.auth.initAuth(loginRes);
    } catch (e) {
      setFormError(e.message);
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-container">
        <img
          src={require("../../Assets/logo/assam-gov-logo-blue.png")}
          alt="Assam Govt Logo"
          className="gov-logo"
        />
        <h2>District Nirikshan</h2>
        <p>Official login for Assam Government Officials</p>

        <form onSubmit={(e) => handleLogin(e)}>
          <div className="input-group">
            <label>Phone Number</label>
            <input
              type="text"
              id="phone"
              name="phone"
              placeholder="Enter your phone number"
              value={form.phone || ""}
              onChange={(e) => {
                updateForm({ phone: e.target.value });
              }}
            />
          </div>
          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Enter your password"
              value={form.password || ""}
              onChange={(e) => {
                updateForm({ password: e.target.value });
              }}
            />
          </div>

          {formError ? <div className="errormsg">{formError}</div> : ""}

          <button type="submit" className="login-btn">
            {loading ? "Logging In" : "Login"}
          </button>
        </form>

        <a href="#" className="forgot-password">
          Forgot Password?
        </a>
        <p className="bottom-text">Powered by Assam Government</p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoggedIn: isLoggedIn(state),
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = "LOGIN_SCREEN") =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const LoginScreen = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LoginScreenInner));

export const SignupScreen = (props) => {
  return <LoginScreen {...props} defaultScreen="signup" />;
};

const styleObj = {
  hidden: {
    display: "none",
  },
};

export default LoginScreen;
